module.exports = __webpack_public_path__ + "fonts/Barlow-Black.9dcd65d.woff2";